module.exports = __webpack_public_path__ + "static/media/CE1.7080a488.jpg";